import { Scale } from "lucide-react";

const ITEMS = [
  "Criminal Law",
  "Civil Law",
  "Family Law",
  "Property Law",
  "Corporate Law",
  "Labour Law",
  "Banking & Finance",
  "Constitutional Law",
  "Intellectual Property",
  "Trusted Counsel",
  "Chavakkad, Kerala",
  "BBA LLB (Hons)",
];

export default function MarqueeRibbon() {
  // Duplicate once for seamless loop
  const loop = [...ITEMS, ...ITEMS];

  return (
    <section
      data-testid="marquee-ribbon"
      className="marquee relative py-6 bg-[#081226] border-y border-[#b89968]/20 overflow-hidden"
    >
      {/* Edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-[#081226] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-[#081226] to-transparent z-10" />

      <div className="marquee-track flex items-center gap-12">
        {loop.map((label, i) => (
          <div key={i} className="flex items-center gap-12 shrink-0">
            <Scale className="w-3.5 h-3.5 text-[#b89968]/70" />
            <span className="font-heading text-xl md:text-2xl italic text-[#e0d5c0] whitespace-nowrap tracking-wide">
              {label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
